
import $ from "jquery";
import tbxHandleNewsFeed from '../sections/news-feed.js';

if ( $('.cumulo-newsandevents').length )
{
	console.log("newsandevents");
	tbxHandleNewsFeed();
}